'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeadText = function LeadText(_ref) {
    var text = _ref.text,
        stylizr = _ref.stylizr,
        theme = _ref.theme;
    return _react2.default.createElement(
        'p',
        { className: theme.leadText, 'data-test-tag': '@spp/ui-lead-text' },
        stylizr(text.value, text.markup)
    );
};

LeadText.propTypes = {
    text: _irisPropTypes.objects.text.isRequired,
    stylizr: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        leadText: _propTypes2.default.string
    })
};

LeadText.defaultProps = {
    stylizr: function stylizr(text) {
        return text;
    },
    theme: {}
};

exports.default = LeadText;
//# sourceMappingURL=LeadText.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-lead-text/lib/cjs/LeadText.js
 ** module id = 524
 ** module chunks = 1
 **/